import actionCreatorFactory from "typescript-fsa";

const actionCreator = actionCreatorFactory("@@Asset");

export const assetActions = {
  fetchMessages: actionCreator.async<{}, {}>("FETCH_MESSAGES"),
  resetToInitialState: actionCreator("RESET_TO_INITIAL_STATE"),
};
